import {CardEnum, MechanicProgressCardsState, NestedReadonly, PlayerColor} from '@colonist/game-states'
import {MechanicValidator} from './MechanicValidator'
import {ActionStatus} from '@colonist/game-base-types'
import {MechanicValidatorProgressCardsPlayer} from './MechanicValidatorProgressCardsPlayer'
import {PlayerValidator} from '../core/PlayerValidator'
import {MapValidator} from '../core/map/MapValidator'
import {CardValidatorOrdered} from '../core/card/CardValidatorOrdered'

export class MechanicValidatorProgressCards extends MechanicValidator {
    private readonly progressCardsPlayerValidators: Map<PlayerColor, MechanicValidatorProgressCardsPlayer>
    readonly bankProgressCards: CardValidatorOrdered

    constructor(playerValidators: PlayerValidator[], mapValidator: MapValidator, progressCardsState: NestedReadonly<MechanicProgressCardsState>) {
        super(playerValidators, mapValidator)

        this.bankProgressCards = new CardValidatorOrdered(progressCardsState.bankProgressCards)
        this.progressCardsPlayerValidators = new Map()
        for(const player in progressCardsState.players) {
            const playerColor = Number(player) as PlayerColor
            const progressCardsPlayerState = progressCardsState.players[playerColor]
            if(progressCardsPlayerState == undefined) continue

            const progressCardsPlayerValidator = new MechanicValidatorProgressCardsPlayer(progressCardsPlayerState)
            this.progressCardsPlayerValidators.set(playerColor, progressCardsPlayerValidator)
        }

        const spectatorProgressCardsPlayerState = new MechanicValidatorProgressCardsPlayer({
            progressCards: {cards: []},
        })
        this.progressCardsPlayerValidators.set(PlayerColor.None, spectatorProgressCardsPlayerState)
    }

    getProgressCardsPlayerValidator(player: PlayerColor): MechanicValidatorProgressCardsPlayer {
        const progressCardsPlayerState = this.progressCardsPlayerValidators.get(player)
        if(progressCardsPlayerState == undefined) throw new Error(`No MechanicProgressCardsPlayerState for player ${player}`)
        return progressCardsPlayerState
    }

    canPlayerUseAtLeastOneProgressCard(player: PlayerColor): boolean {
        for(const card of this.getProgressCardsPlayerValidator(player).progressCards.cards) {
            if(!this.canPlayerUseProgressCard(player, card).canTakeAction) continue
            return true
        }
        return false
    }

    canPlayerUseProgressCard(player: PlayerColor, cardEnum: CardEnum): ActionStatus {
        const hasCard = this.getPlayersProgressCardCountForCard(player, cardEnum) > 0
        return {canTakeAction: hasCard}
    }

    getPlayersTotalProgressCards(player: PlayerColor): number {
        const devCardsPlayerState = this.getProgressCardsPlayerValidator(player)
        return devCardsPlayerState.progressCards.cards.length
    }

    getPlayersProgressCardCountForCard(player: PlayerColor, cardEnum: CardEnum): number {
        const progressCardsPlayerValidator = this.getProgressCardsPlayerValidator(player)
        return progressCardsPlayerValidator.progressCards.getCardCountForCard(cardEnum)
    }

    hasProgressCardsInPlayerHand(player: PlayerColor, cardEnums: CardEnum[]): boolean {
        const progressCardsPlayerValidator = this.getProgressCardsPlayerValidator(player)
        return progressCardsPlayerValidator.progressCards.hasCardsInInventory(cardEnums)
    }
}
